const awsConfigProd = {
  aws_project_region: 'eu-west-2',
  aws_appsync_graphqlEndpoint:
    'https://js44v4ijtrb37l3267dtmjzh7e.appsync-api.eu-west-2.amazonaws.com/graphql',
  aws_appsync_region: 'eu-west-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_cognito_identity_pool_id:
    'eu-west-2:3e7bcfee-c232-4c72-998b-84b546df92c8',
  aws_cognito_region: 'eu-west-2',
  aws_user_pools_id: 'eu-west-2_64PMXwTSS',
  aws_user_pools_web_client_id: '1o3mcehrss7m1rm86rkf1kdp0j',
  oauth: {
    domain: 'auth.joinpopp.com',
    scope: [
      'phone',
      'email',
      'openid',
      'profile',
      'aws.cognito.signin.user.admin'
    ],
    redirectSignIn: 'http://localhost:3000/,https://ai.joinpopp.com/',
    redirectSignOut: 'http://localhost:3000/,https://ai.joinpopp.com/',
    responseType: 'code'
  },
  auth0Logout: {
    'Robertwalters-dev': {
      domain: 'auth.sso.joinpopp.com',
      clientId: 'eNbRMUMA2CraKaigoke3xry53eUNHHt5'
    },
    'Robertwalters-staging': {
      domain: 'auth.sso.joinpopp.com',
      clientId: 's3uUP35x2GJx1P7cfZawmVR9S3st3DJj'
    },
    'Robertwalters-qa': {
      domain: 'auth.sso.joinpopp.com',
      clientId: 'jcLJYROUflSulPJwfSFlXfpYemBs5gcy'
    },
    Robertwalters: {
      domain: 'auth.sso.joinpopp.com',
      clientId: 'fKHotRu8OoMun6qA0K9W2IYcSnQSqNjB'
    },
    Auth0: {
      domain: 'auth.sso.joinpopp.com',
      clientId: 'hUybCHCBOogkgBl1oSXFvN0EEVKm0sHY'
    }
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: ['GOOGLE'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: []
  },
  aws_cognito_verification_mechanisms: ['EMAIL']
};

// eslint-disable-next-line no-undef
module.exports = awsConfigProd;
